import React from "react";
import logo from "../Assets/images/logo-white.png";

function Loading() {
  return (
    <div className="loading-container">
      {/* Logo */}
      <img src={logo} alt="EMD Logo" className="loading-logo" />

      {/* Spinner */}
      <div className="spinner"></div>
    </div>
  );
}

export default Loading;
